module.exports = __webpack_public_path__ + "static/media/chat-blue-icon.f2b6b911.svg";